// The dashboard's two structural primitives, shared by every tab.
//
// They lived in DashboardPage until the Creative and Offline tabs needed them. Copying them
// would have been the faster edit and the wrong one: the ink rule above a band and the panel
// inset are what make the tabs read as one dashboard rather than three pages that happen to
// sit behind the same header.

import { T } from '../../../../shared/styles/tokens.js';

/** Section heading with the ink rule above it. One per major block of a tab. */
export function Band({ title, sub, children }) {
  return (
    <section style={{ marginBottom: T.s7 }}>
      <div style={{
        borderTop: `2px solid ${T.ink}`, paddingTop: T.s3, marginBottom: T.s4,
        display: 'flex', alignItems: 'baseline', gap: T.s3, flexWrap: 'wrap',
      }}>
        <h2 style={{
          margin: 0, fontFamily: T.fontDisplay, fontSize: '1.25rem',
          fontWeight: 600, letterSpacing: '-.02em',
        }}>{title}</h2>
        {sub && <span style={{ fontSize: T.tSmall, color: T.text3 }}>{sub}</span>}
      </div>
      {children}
    </section>
  );
}

/** A single framed chart or table inside a Band. */
export function Panel({ title, children }) {
  return (
    <div className="o-panel" style={{ padding: `${T.s4}px ${T.s5}px` }}>
      {title && <p className="o-eyebrow" style={{ marginBottom: T.s3 }}>{title}</p>}
      {children}
    </div>
  );
}

/** Ink at a given alpha, for heat shading. Derived from the token so it cannot drift. */
export const inkAlpha = (a) => {
  const n = parseInt(T.ink.replace('#', ''), 16);
  return `rgba(${(n >> 16) & 255},${(n >> 8) & 255},${n & 255},${a})`;
};
